var map = {
	"./Boreal-Besties.jpg": 18,
	"./Boreal-Besties2.jpg": 51,
	"./Boreal-Besties3.jpg": 52,
	"./Boreal-Besties4.jpg": 53,
	"./Boreal-Besties5.jpg": 54,
	"./Boreal-Besties6.jpg": 55,
	"./Boreal-Besties7.jpg": 56,
	"./Boreal-Besties8.jpg": 57,
	"./Boreal-Besties9.jpg": 58
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50;